import React, { useState } from "react";
import { useFormik } from "formik";
import { Auth } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { inititalValues, validationSchema } from "./LoginForm.form";
import { image } from "../../../../datos";

const authController = new Auth();

export function LoginForm() {
  const { login } = useAuth();
  const [msg, setMsg] = useState("");
  const [showError, setShowError] = useState(false);

  const formik = useFormik({
    initialValues: inititalValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        const response = await authController.login(formValue);
        authController.setAccessToken(response.access);
        authController.setRefreshToken(response.refresh);
        login(response.access);
      } catch (error) {
        console.error(error);
        handleOnError();
        setMsg(error.msg);
      }
    },
  });

  const handleShowError = () => {
    // const MAX_ERRORS = 5;
    // const errorCount = getErrorCount(); // función que devuelve el número actual de errores
    // if (msg) {
    setShowError(true);
    setTimeout(() => setShowError(false), 5000); // oculta el mensaje después de 5 segundos
    // }
  };

  const handleOnError = () => {
    // logError(); // función que registra el error
    handleShowError(); // muestra el mensaje de error si se ha alcanzado el número máximo de errores
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 h-screen w-full">
      {/* Image del Cover */}
      <div className="hidden sm:block">
        <img
          src={image.retropc}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="bg-gray-800 flex flex-col justify-center">
        <form
          onSubmit={formik.handleSubmit}
          className="max-w-[400px]  w-full mx-auto rounded-lg bg-gray-900 p-8 px-8"
        >
          {showError && <label>{msg}</label>}
          {/* Titulo */}
          <h2 className="text-4x1 dark:text-white font-bold text-center">
            SIGN IN
          </h2>
          <div className="flex flex-col text-gray-400 py-2">
            <label>Correo</label>
            <input
              className="rounded-lg bg-gray-700 mt-2 p-2 focus:border-blue-500 focus:bg-gray-800 focus:outline-none"
              type="text"
              name="email"
              placeholder="Correo Electronico"
              onChange={formik.handleChange}
              value={formik.values.email}
              error={formik.errors.email}
            />
          </div>
          <div className="flex flex-col text-gray-400 py-2">
            <label>Contraseña</label>
            <input
              className="rounded-lg bg-gray-700 mt-2 p-2 focus:border-blue-500 focus:bg-gray-800 focus:outline-none"
              type="password"
              name="password"
              placeholder="Contraseña"
              onChange={formik.handleChange}
              value={formik.values.password}
              error={formik.errors.password}
            />
          </div>
          {/* Opciones  */}
          <div className="flex justify-between text-gray-400 py-2">
            <p className="flex items-center">
              <input className="mr-2" type="checkbox" /> Recordarme
            </p>
            <p>¿Olvide la Contraseña?</p>
          </div>
          <button
            type="submit"
            // onClick={formik.isSubmitting}
            className="w-full my-5 py-2 bg-teal-500 shadow-lg shadow-teal-500/50 hover:shadow-teal-500/40 text-white font-semibold rounded-lg "
          >
            Entrar
          </button>
        </form>
      </div>
    </div>
  );
}
